import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/queryClient';
import RequireAdmin from './components/RequireAdmin';
import Dashboard from './routes/Dashboard';
import Login from './routes/auth/Login';
import Signup from './routes/auth/Signup';
import Callback from './routes/auth/Callback';
import AdminQueue from './routes/admin/Queue';
import AdminListings from './routes/admin/Listings';
import AdminEvents from './routes/admin/Events';
import AdminBlog from './routes/admin/Blog';
import AdminResources from './routes/admin/Resources';
import AdminTips from './routes/admin/Tips';
import ListingForm from './routes/admin/ListingForm';
import EventForm from './routes/admin/EventForm';
import BlogPostForm from './routes/admin/BlogPostForm';
import ResourceForm from './routes/admin/ResourceForm';
import TipForm from './routes/admin/TipForm';
import NotFound from './routes/NotFound';

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/auth/callback" element={<Callback />} />

          <Route path="/admin" element={<RequireAdmin><AdminQueue /></RequireAdmin>} />
          <Route path="/admin/listings" element={<RequireAdmin><AdminListings /></RequireAdmin>} />
          <Route path="/admin/listings/new" element={<RequireAdmin><ListingForm mode="new" /></RequireAdmin>} />
          <Route path="/admin/listings/:id" element={<RequireAdmin><ListingForm mode="edit" /></RequireAdmin>} />
          <Route path="/admin/events" element={<RequireAdmin><AdminEvents /></RequireAdmin>} />
          <Route path="/admin/events/new" element={<RequireAdmin><EventForm mode="new" /></RequireAdmin>} />
          <Route path="/admin/events/:id" element={<RequireAdmin><EventForm mode="edit" /></RequireAdmin>} />
          <Route path="/admin/blog" element={<RequireAdmin><AdminBlog /></RequireAdmin>} />
          <Route path="/admin/blog/new" element={<RequireAdmin><BlogPostForm mode="new" /></RequireAdmin>} />
          <Route path="/admin/blog/:id" element={<RequireAdmin><BlogPostForm mode="edit" /></RequireAdmin>} />
          <Route path="/admin/resources" element={<RequireAdmin><AdminResources /></RequireAdmin>} />
          <Route path="/admin/resources/new" element={<RequireAdmin><ResourceForm mode="new" /></RequireAdmin>} />
          <Route path="/admin/resources/:id" element={<RequireAdmin><ResourceForm mode="edit" /></RequireAdmin>} />
          <Route path="/admin/tips" element={<RequireAdmin><AdminTips /></RequireAdmin>} />
          <Route path="/admin/tips/:id" element={<RequireAdmin><TipForm mode="edit" /></RequireAdmin>} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
